import { styled } from "styled-components";

export const StyledDivider = styled.div`
  height: 1px;
  align-self: stretch;
  background: #e9ebf2;
`;
